// Componentes propios de GT Cantra sobre Dawn

if (!customElements.get('cantra-reviews')) {
  customElements.define(
    'cantra-reviews',
    class CantraReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.dots.length < 2) return;

        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index() - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index() + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      }

      index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      go(i) {
        const total = this.dots.length;
        const target = ((i % total) + total) % total;
        this.track.scrollTo({ left: target * this.track.clientWidth });
      }

      sync() {
        const current = this.index();
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      }
    }
  );
}
